import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { QRCodeCanvas } from 'qrcode.react';
//import Swal from "sweetalert2";
import { fetchAllVehicles, fetchAllVehiclesOracle } from '../../services/Combustible/vehiculoService';
import { Vehiculo } from '../../types/vehiculo';
import VehiclePicker, { VehiclePickerHandles } from '../shared/VehiclePicker';
import { useAuth } from '../../context/AuthContext';
import { upsertVehiculo } from '../../services/Combustible/vehiculoService';

interface QRCodeData {
    value: string;
    label: string;
    vehiculo: Vehiculo;
}

interface QRPageProps {
    codes: QRCodeData[];
    onRemove: (placaEnLista: string) => void;
}

interface VehicleTableProps {
    vehicles: Vehiculo[];
    mismatchedPlacas: string[];
    getColorForPlaca: (placa: string) => string;
    onUpdateCeCo: (vehicle: Vehiculo) => void;
    isOracle?: boolean;
}

const VehicleTable: React.FC<VehicleTableProps> = ({ vehicles, mismatchedPlacas, getColorForPlaca, onUpdateCeCo, isOracle }) => {
    return (
        <div className='overflow-auto' style={{ height: '300px', maxHeight: '350px' }}>
            <table className='table table-sm table-responsive'>
                <thead>
                    <tr>
                        <th>Placa</th>
                        <th>Unidad</th>
                        <th>Centro Costo</th>
                        <th>Descripción Centro Costo</th>
                        {isOracle && (<th className='text-center'>Acción</th>)}
                    </tr>
                </thead>
                <tbody>
                    {vehicles.map((vehicle, index) => {
                        const isMismatched = mismatchedPlacas.includes(vehicle.Placa);
                        const customColor = getColorForPlaca(vehicle.Placa);
                        //console.log(`Color: ${customColor} placa: ${vehicle.Placa}`);
                        return (
                            <tr key={index}>
                                <td
                                    className="position-relative"
                                    style={{
                                        backgroundColor: isMismatched ? customColor : 'inherit',
                                        borderLeft: `4px solid ${isMismatched ? customColor : 'transparent'}`
                                    }}
                                >
                                    {vehicle.Placa}
                                </td>
                                <td
                                    style={{
                                        backgroundColor: isMismatched ? customColor : 'inherit',
                                        borderLeft: `4px solid ${isMismatched ? customColor : 'transparent'}`
                                    }}
                                >
                                    {vehicle.NumeroUnidad}
                                </td>
                                <td style={{
                                    backgroundColor: isMismatched ? customColor : 'inherit'
                                }}>{vehicle.CentroCosto}</td>
                                <td style={{
                                    backgroundColor: isMismatched ? customColor : 'inherit'
                                }}>{vehicle.CentroCostoDesc}</td>
                                {isOracle && (
                                    <td className='text-center' style={{ backgroundColor: isMismatched ? customColor : 'inherit' }}>
                                        {isMismatched && (
                                            < button
                                                className='btn btn-link p-0'
                                                onClick={() => onUpdateCeCo(vehicle)}
                                                title='Actualizar Datos '
                                                style={{ cursor: 'pointer' }}
                                                aria-label={`Actualizar datos para ${vehicle.Placa}`}
                                            >
                                                <i className="fas fa-sync-alt text-primary"></i>
                                            </button>
                                        )}

                                    </td>
                                )}

                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div >
    )
};


const QRPage: React.FC<QRPageProps> = ({ codes, onRemove }) => {
    return (
        <div
            className="container border my-3"
            style={{ width: '8.5in', height: '8.5in', padding: '10mn' }}
        >
            <div className="row">
                {codes.map((code, index) => (
                    <div key={index} className="col-6 col-md-3 text-center mb-3">
                        <QRCodeCanvas value={code.value} size={150} />
                        <p>{code.label}</p>
                        <button
                            className="btn btn-danger btn-sm d-print-none"
                            onClick={() => onRemove(code.value)}
                            title={`Quitar de la lista ${code.value}`}
                        >
                            X
                        </button>
                    </div>
                ))}
            </div>
            {/** Salto de página para impresión (necesario, ya que bootstrap no lo incluye) */}
            <div style={{ pageBreakAfter: 'always' }} />
        </div>
    );
};

const GenerateQRCodeList: React.FC = () => {
    const [qrCodes, setQrCodes] = useState<QRCodeData[]>([]);
    const [allVehicles, setAllVehicles] = useState<Vehiculo[]>([]);
    const [activeTab, setActiveTab] = useState<string>("QR");
    const { user } = useAuth();
    const [oracleVehicles, setOracleVehicles] = useState<Vehiculo[]>([]);
    const [sqlVehicles, setSqlVehicles] = useState<Vehiculo[]>([]);
    const [isBulkUpdateting, setIsBulkUpdating] = useState<boolean>(false);

    useEffect(() => {
        loadVehicles();
    }, []);

    const getColorForPlaca = (placa: string) => {
        const hue = ((placa.charCodeAt(0) + placa.charCodeAt(placa.length - 1)) * 15) % 360;
        return `hsla(${hue}, 70%, 80%, 0.3)`;
    };

    // Encontrar placas con diferencias
    const mismatchedPlacas = oracleVehicles
        .filter(ov => {
            const sqlVehicle = sqlVehicles.find(sv => sv.Placa === ov.Placa);
            return sqlVehicle && (sqlVehicle.CentroCosto !== ov.CentroCosto || sqlVehicle.NumeroUnidad !== ov.NumeroUnidad);
        }).map(v => v.Placa);




    const handleUpdateCeCo = async (vehicle: Vehiculo, showAlert: boolean = true) => {
        console.log('Placa a cambiar', vehicle);
        if (!vehicle.CentroCostoDesc) {
            Swal.fire({
                icon: 'error',
                title: 'Error en actualización',
                text: 'No se puede actualizar el Centro de Costo con la descripción vacía',
            });
            return
        }
        try {
            const vehicleToUpdate = {
                ...vehicle,
                CentroCosto: vehicle.CentroCosto,
                CentroCostoDesc: vehicle.CentroCostoDesc,
                NumeroUnidad: vehicle.NumeroUnidad,
                created_by: user?.User.email || ''
            };
            console.log('Actualizando: ', vehicleToUpdate);
            await upsertVehiculo(vehicleToUpdate);

            //Actualiza los datos localmente
            setSqlVehicles(prev =>
                prev.map(v =>
                    v.Placa === vehicle.Placa
                        ? {
                            ...v, CentroCosto: vehicle.CentroCosto,
                            CentroCostoDesc: vehicle.CentroCostoDesc,
                            NumeroUnidad: vehicle.NumeroUnidad
                        }
                        : v
                )
            );
            if (showAlert) {
                Swal.fire({
                    icon: 'success',
                    title: 'Actualización exitosa',
                    text: `CeCo actualizado para ${vehicle.Placa}`,
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            return { sucess: true, placa: vehicle.Placa };



        } catch (error: any) {
            console.error(`Error actualizando ${vehicle.Placa}:`, error);
            if (showAlert) {
                Swal.fire({
                  icon: 'error',
                  title: 'Error en actualización',
                  text: `Fallo en ${vehicle.Placa}`,
                });
              }
            return { success: false, placa: vehicle.Placa, error };
        }
    };

    const handleBulkUpdaCeCo = async () => {
        try {
            setIsBulkUpdating(true);
            //1. Obtiene todos los vehiculos con diferencias
            const toUpdate = oracleVehicles.filter(ov => {
                const tieneDiferencia = mismatchedPlacas.includes(ov.Placa);
                const descValida = ov.CentroCosto?.trim() !== '' && ov.CentroCostoDesc !== null;
                return tieneDiferencia && descValida;
                //return mismatchedPlacas.includes(ov.Placa);
            });
            console.log('a actualizar: ', toUpdate);
                

            // 2. Validar que hay elementos para actualizar    
            if (toUpdate.length === 0) {
                Swal.fire('Info', 'No hay registros para actualizar', 'info');
                return;
            }
            // 3. Confirmación de usuario
            const result = await Swal.fire({
                title: `¿Actualizar ${toUpdate.length} registros?`,
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, actualizar',
                cancelButtonText : 'Cancelar'
            });

            if (!result.isConfirmed) return;

            //4. Ejecutar todas las actualizaciones
            const updatePromises = toUpdate.map(vehicle =>
                handleUpdateCeCo(vehicle, false).catch(error => ({
                    success: false,
                    placa: vehicle.Placa,
                    error
                }))
            );

            //5. Esperar a que todas se completen
            const results = await Promise.all(updatePromises);

            //6. Procesar resultados
            const failedUpdates = results.filter(r => !r?.success);

            if (failedUpdates.length === 0) {
                Swal.fire(
                    'Éxito',
                    `Todos los ${toUpdate.length} registros se actualizaron correctamente`,
                    'success'
                );
            } else {
                Swal.fire(
                    'Advertencia',
                    `Actualizados ${toUpdate.length - failedUpdates.length} de ${toUpdate.length} registros. Fallos: ${failedUpdates.map(f => f?.placa).join(', ')}`,
                    'warning'
                );
            }

        } catch (error) {
            Swal.fire('Error', 'Error en la actualización masiva', 'error');
        } finally {
            setIsBulkUpdating(false);
        }
    };

    const pickerRef = useRef<VehiclePickerHandles>(null)


    //Definr cuántos  QR se mostrarán por "hoja"
    const codesPerPage = 8;
    const pages: QRCodeData[][] = [];
    for (let i = 0; i < qrCodes.length; i += codesPerPage) {
        pages.push(qrCodes.slice(i, i + codesPerPage));
    }


    const handlePrint = () => {
        window.print();
    };

    const handleRemoveQRCode = (codeToRemove: string) => {
        //console.log('entre a borrar codigo: ', codeToRemove, qrCodes);
        const removedItem = qrCodes.find((item) => item.value === codeToRemove);

        setQrCodes(qrCodes.filter((vehicle) => vehicle.value !== codeToRemove));
        if (removedItem) {
            setAllVehicles(prevVehicles =>
                [...prevVehicles, removedItem.vehiculo].sort((a, b) => a.Placa.localeCompare(b.Placa))
            );
        }
    };

    const clearAllQRCodes = () => {
        const vehiclesFromQRCodes = qrCodes.map(item => item.vehiculo);
        setAllVehicles(prevVehicles =>
            [...prevVehicles, ...vehiclesFromQRCodes].sort((a, b) => a.Placa.localeCompare(b.Placa))
        );
        setQrCodes([]);
    }

    const loadVehicles = async () => {
        try {
            const [vehiclesOracle, vehiclesSql] = await Promise.all([
                fetchAllVehiclesOracle(),
                fetchAllVehicles()
            ]);
            //Crea listas para el tab de Arreglo de CECOS
            if (vehiclesOracle) {
                //Deja solo los que están en los dos 
                setOracleVehicles(vehiclesOracle.filter((v) =>
                    vehiclesSql.some((sqlV) => sqlV.Placa === v.Placa)).sort((a, b) => a.Placa.localeCompare(b.Placa)));
            }
            if (vehiclesSql) {
                setSqlVehicles(vehiclesSql);
            }

            //Quita los repetidos de la lista del combo
            const filteredOracleVehicles = vehiclesOracle.filter((oracleVehicle: Vehiculo) =>
                !vehiclesSql.some((sqlVehicle: Vehiculo) => sqlVehicle.Placa === oracleVehicle.Placa)
            );

            const allVehicles = [...vehiclesSql, ...filteredOracleVehicles].sort((a, b) => a.Placa.localeCompare(b.Placa));

            setAllVehicles(allVehicles);
        } catch (error) {
            console.error('Error al cargar vehículos', error);
        }
    };

    const handleVehicleSelect = (vehicle: Vehiculo) => {
        if (!qrCodes.some(v => v.value === vehicle.Placa)) {
            setQrCodes([...qrCodes, { value: vehicle.Placa, label: vehicle.Placa, vehiculo: vehicle }]);
        }
        setAllVehicles(allVehicles.filter(v => v.Placa !== vehicle.Placa));
        if (pickerRef.current) {
            pickerRef.current.clearSearch();
        }
    };

    return (
        <div className="container my-4">
            <ul className="nav nav-tabs  d-print-none">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'QR' ? "active bg-light" : ""}`}
                        onClick={() => setActiveTab('QR')}
                    >
                        Generar QR
                    </button>
                </li>
                <li className={`nav-item ${user?.User.role === 'Administrador' ? '' : 'd-none'}`}>
                    <button
                        className={`nav-link ${activeTab === 'CECOS' ? 'active bg-light' : ''}`}
                        onClick={() => setActiveTab('CECOS')}
                    >
                        Actualizar Cecos
                    </button>
                </li>
            </ul>
            <div className="tab-content">
                {activeTab === "QR" && (
                    <div className="tab-pane active">
                        <h2 className='d-print-none'>Generar lista de códigos QR</h2>
                        <div className="row d-print-none">
                            <div className="col">
                                <VehiclePicker vehicles={allVehicles} onSelect={handleVehicleSelect} ref={pickerRef} />
                                <div className="button-group mt-2">
                                    <button className="btn btn-success btn-sm  m-2" onClick={handlePrint} disabled={qrCodes.length === 0}>
                                        Imprimir lista de QR
                                        <i className="fas fa-print ms-2"></i>
                                    </button>
                                    <button
                                        className='btn btn-danger btn-sm m-2'
                                        onClick={() => {
                                            clearAllQRCodes();
                                        }}
                                        disabled={qrCodes.length === 0}
                                    >
                                        Limpiar
                                        <i className="fas fa-recycle ms-2"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mt-2" id='list'>
                                    {pages.map((pageCodes, index) => (
                                        <QRPage
                                            key={index}
                                            codes={pageCodes}
                                            onRemove={handleRemoveQRCode}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === "CECOS" && (
                    <div className="tab-pane active">
                        <div className="container">
                            <div className="row">
                                <div className="col border-end me-2 pe-5" >
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span>Vehículos en Oracle: {oracleVehicles.length}</span>
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={handleBulkUpdaCeCo}
                                            disabled={mismatchedPlacas.length === 0 || isBulkUpdateting}
                                            title='Actualizar todos los registros diferentes'
                                        >
                                            {isBulkUpdateting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Actualizando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-sync me-2"></i>
                                                    Actualizar todos ({mismatchedPlacas.length})
                                                </>
                                            )}

                                        </button>
                                    </div>
                                    <VehicleTable
                                        vehicles={oracleVehicles}
                                        mismatchedPlacas={mismatchedPlacas}
                                        getColorForPlaca={getColorForPlaca}
                                        onUpdateCeCo={handleUpdateCeCo}
                                        isOracle={true}
                                    />
                                </div>
                                {/* <div className="col">
                                    <div className="btn-group"> 
                                        <button className="btn btn-primary btn-sm m-2">Actualizar</button>
                                        <button className="btn btn-success btn-sm  m-2" onClick={handlePrint} disabled={qrCodes.length === 0}>
                                            Imprimir lista de QR
                                            <i className="fas fa-print ms-2"></i>
                                        </button>
                                    </div>
                                </div> */}
                                <div className="col">
                                    Vehículos en SQL: {sqlVehicles.length}
                                    <VehicleTable
                                        vehicles={sqlVehicles}
                                        mismatchedPlacas={mismatchedPlacas}
                                        getColorForPlaca={getColorForPlaca}
                                        onUpdateCeCo={handleUpdateCeCo}

                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div >
    )
};

export default GenerateQRCodeList;
